<template>
  <div class="section py-0">
    <div class="section pb-0">
      <div class="columns">
        <div class="column">
          <b-button
            type="is-gold is-outlined"
            icon-left="plus"
            icon-pack="fas"
            tag="router-link"
            :to="{ name: 'NewNews' }"
            class="mr-3"
          >
            Neuigkeit verfassen
          </b-button>
          <b-dropdown
            :triggers="['hover']"
            aria-role="list"
            position="is-bottom-right"
          >
            <template #trigger>
              <b-button type="is-gold is-outlined" icon-right="caret-down">
                Aktionen
              </b-button>
            </template>

            <b-dropdown-item @click="confirmBulkDeactivation"
              >Deaktivieren</b-dropdown-item
            >
            <b-dropdown-item @click="confirmBulkDelete"
              >Löschen</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <div class="column is-narrow">
          <b-dropdown>
            <template #trigger="{ active }">
              <b-button
                :label="categorySelectLabel"
                :icon-right="active ? 'angle-up' : 'angle-down'"
              />
            </template>
            <b-dropdown-item custom>
              <b-checkbox v-model="allCategories"> All categories </b-checkbox>
            </b-dropdown-item>
            <hr class="my-0" />
            <b-dropdown-item
              v-for="category in categories"
              :key="category.id"
              custom
            >
              <b-checkbox v-model="categoryFilters" :native-value="category.id">
                {{ category.name }}
              </b-checkbox>
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div class="column is-narrow">
          <b-field>
            <b-input
              v-model="search"
              placeholder="Neuigkeit suchen..."
              type="search"
              icon-pack="fas"
              icon="search"
            >
            </b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="section">
      <b-table
        icon-pack="fa"
        :data="filteredNews"
        checkable
        :checked-rows.sync="checkedRows"
        checkbox-position="left"
        :paginated="filteredNews.length > 20"
        :per-page="rangeRows"
        :default-sort="['created_at', 'desc']"
        hoverable
        @sort="onSort"
        backend-sorting
        ref="newsTable"
      >
        <b-table-column field="title" label="Titel" sortable v-slot="{ row }">
          {{ row.title }}
        </b-table-column>

        <b-table-column
          field="created_at"
          label="Datum"
          sortable
          v-slot="{ row }"
        >
          {{ new Date(row.created_at).toLocaleDateString("de-DE") }}
        </b-table-column>

        <b-table-column
          field="visible"
          label="Status"
          sortable
          v-slot="{ row }"
        >
          <b-icon
            icon="circle"
            :type="row.visible ? 'is-success' : 'is-danger'"
          />
        </b-table-column>

        <b-table-column
          field="category_id"
          label="Kategorie"
          sortable
          v-slot="{ row }"
        >
          <news-category-tag
            v-if="row.category_id"
            :data="theCategory(row.category_id)"
          />
        </b-table-column>

        <b-table-column field="action" label="" width="40" v-slot="{ row }">
          <router-link :to="{ name: 'ViewNews', params: { newsId: row.id } }">
            <b-icon icon="arrow-right" icon-pack="fas"></b-icon>
          </router-link>
        </b-table-column>

        <template #bottom-left>
          <b-select v-model="rangeRows">
            <option value="20">20 pro Seite</option>
            <option value="50">50 pro Seite</option>
            <option value="100">100 pro Seite</option>
            <option value="500">500 pro Seite</option>
          </b-select>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
/* eslint-disable max-len */
import { mapGetters } from "vuex";
import helper from "@/functions/helper";
import NewsCategoryTag from "@/components/editNews/NewsCategoryTag.vue";

export default {
  name: "AllNews",
  components: {
    NewsCategoryTag
  },
  data() {
    return {
      search: "",
      checkedRows: [],
      rangeRows: 20,
      categoryFilters: []
    };
  },
  computed: {
    ...mapGetters({
      news: "news/data",
      categories: "newsCategory/data",
      theCategory: "newsCategory/dataById",
      loading: "isLoading"
    }),
    theNews() {
      return this.news.filter(news =>
        this.categoryFilters.includes(news.category_id)
      );
    },
    filteredNews() {
      return helper.search(this.theNews, ["title"], this.search);
    },
    categorySelectLabel() {
      let label = "";

      if (this.categoryFilters.length === 0) {
        label = "Category";
      } else if (this.categoryFilters.length === this.categories.length) {
        label = "All categories";
      } else if (this.categoryFilters.length === 1) {
        label = this.theCategory(this.categoryFilters[0]).name;
      } else if (this.categoryFilters.length > 1) {
        label = `${this.categoryFilters.length} categories`;
      }

      return label;
    },
    allCategories: {
      get() {
        return this.categoryFilters.length === this.categories.length;
      },
      set(value) {
        this.categoryFilters = value
          ? [...this.categories.map(category => category.id)]
          : [];
      }
    }
  },
  watch: {
    loading: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal === false && oldVal === true) {
          this.selectAllCategoryFilter();
        }
      }
    }
  },
  methods: {
    onSort(field, order) {
      console.log("sort now");
      this.filteredNews.sort((a, b) => {
        // By default we want to use the column value as it is
        let x = a[field];
        let y = b[field];

        // However, for certain field, we want to transform it first
        switch (field) {
          case "title":
            x = x.toUpperCase();
            y = y.toUpperCase();
            break;
          case "visible":
            x = x ? 1 : 0;
            y = y ? 1 : 0;
            break;
          case "category_id":
            x = this.theCategory(x).name.toUpperCase();
            y = this.theCategory(y).name.toUpperCase();
            break;
          default:
            break;
        }

        if (order === "desc") {
          if (x > y) {
            return -1;
          }

          if (x < y) {
            return 1;
          }

          return 0;
        }

        // asc
        if (x < y) {
          return -1;
        }

        if (x > y) {
          return 1;
        }

        return 0;
      });
    },
    confirmBulkDeactivation() {
      this.$buefy.dialog.confirm({
        title: "Produkt deaktivieren",
        // eslint-disable-next-line max-len
        message:
          "Sind Sie sicher, dass Sie alle ausgewählen Neuigkeiten deaktivieren möchten?",
        confirmText: "Neuigkeiten deaktivieren",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.disableNews)
      });
    },
    confirmBulkDelete() {
      this.$buefy.dialog.confirm({
        title: "Produkt löschen",
        // eslint-disable-next-line max-len
        message:
          "Sind Sie sicher, dass Sie alle ausgewählen Neuigkeiten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden!",
        confirmText: "Neuigkeiten löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => this.bulkAction(this.deleteNews)
      });
    },
    disableNews({ id }) {
      this.$store.dispatch("news/UPDATE", {
        id,
        visible: false
      });
    },
    deleteNews({ id }) {
      this.$store.dispatch("news/DELETE", { id });
    },
    bulkAction(action) {
      this.checkedRows.forEach(action);
      this.checkedRows = [];
    },
    selectAllCategoryFilter() {
      this.categoryFilters = [...this.categories.map(category => category.id)];
    }
  },
  created() {
    this.selectAllCategoryFilter();
  },
  mounted() {
    this.$refs.newsTable.initSort();
  }
};
</script>
